import React from 'react';
import { Aperture } from 'lucide-react';

export default function Hero({ lang }) {
  const t = {
    line1: 'POSE',
    line2: 'BEAUTY',
    line3: lang === 'de' ? 'MODE' : 'FASHION',
    tagline:
      lang === 'de'
        ? 'DEIN BLICK. DEIN SCHNITT. DEINE HAUT.'
        : 'YOUR GAZE. YOUR CUT. YOUR SKIN.',
    sub:
      lang === 'de'
        ? 'ModelCamp ist ein Atelier für angehende Models. Du übst Haltung vor der Kamera, baust Beauty-Routinen und setzt Mode so, dass sie zu deiner Silhouette passt.'
        : 'ModelCamp is an atelier for aspiring models. You practise presence in front of the camera, build beauty routines and style clothes to your silhouette.',
    cta: lang === 'de' ? 'ATELIER ÖFFNEN' : 'OPEN THE ATELIER',
    badgeLabel: lang === 'de' ? 'Studio heute' : 'Studio today',
    badgeValue: lang === 'de' ? 'Look 01, Tageslicht' : 'Look 01, daylight',
    proof: lang === 'de' ? 'Atelier für Mode, Beauty und Models' : 'Atelier for fashion, beauty and models',
  };

  return (
    <section className="pt-16 min-h-screen flex items-center bg-[#faf7f4] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center py-16 lg:py-24">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-1">
              {[t.line1, t.line2, t.line3].map((word, i) => (
                <span
                  key={word}
                  className={`text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black tracking-tight leading-none ${
                    i === 1 ? 'text-rose-900' : 'text-stone-900'
                  }`}
                >
                  {word}
                </span>
              ))}
            </div>

            <p className="text-xl sm:text-2xl font-bold text-stone-800 tracking-wide uppercase">
              {t.tagline}
            </p>

            <p className="text-lg text-stone-500 max-w-md leading-relaxed">{t.sub}</p>

            <div className="pt-2">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-8 py-4 bg-stone-900 hover:bg-rose-950 text-white font-bold text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
              >
                {t.cta}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.5}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </a>
            </div>

            <p className="text-sm text-stone-500 pt-2">
              <span className="font-semibold text-stone-800">ModelCamp</span> {t.proof}
            </p>
          </div>

          <div className="relative flex justify-center lg:justify-end">
            <div className="absolute inset-0 -z-10 flex items-center justify-center">
              <div className="w-[420px] h-[420px] rounded-full bg-gradient-to-br from-rose-100 to-stone-200 blur-3xl opacity-70" />
            </div>

            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-2 rounded-3xl bg-gradient-to-br from-rose-300/30 to-stone-400/20 blur-sm -z-10" />
              <img
                src="https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&w=1600&q=80"
                alt={lang === 'de' ? 'Model mit Sonnenbrille vor einer gelben Wand' : 'Model with sunglasses against a yellow wall'}
                className="w-full h-[480px] lg:h-[560px] object-cover rounded-3xl shadow-2xl"
              />
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-2xl px-5 py-3 shadow-xl flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-stone-900 flex items-center justify-center text-white">
                  <Aperture size={18} />
                </div>
                <div>
                  <p className="text-xs text-stone-400 font-medium uppercase tracking-wide">
                    {t.badgeLabel}
                  </p>
                  <p className="text-sm font-bold text-stone-800">{t.badgeValue}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
